/** Same public project as the mobile/desktop apps (anon key is safe in the client). */
export const SUPABASE_URL = "https://wwwjsvtikncdnujgdqcf.supabase.co";

export const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind3d2pzdnRpa25jZG51amdkcWNmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU5MjEyMDMsImV4cCI6MjA5MTQ5NzIwM30.0aiEKPL8B1OMFrhfJsAJqi4F0KAmQNfpyJEYXko-aqk";

export function isSupabaseConfigured() {
  return (
    typeof SUPABASE_URL === "string" &&
    SUPABASE_URL.startsWith("http") &&
    typeof SUPABASE_ANON_KEY === "string" &&
    SUPABASE_ANON_KEY.length > 20
  );
}
